<template>
  <v-app>
    <nav>
      <v-app-bar app dense>
        <div>
          <BreadCrumb/>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          text
          href="https://www.inovenso.com/"
          target="_blank"
        >
          <span class="mr-2">Inovenso.com</span>
        </v-btn>
      </v-app-bar>     
      <Snackbar />     
      <v-main class="pa-1">
        <router-view/>
      </v-main>
    </nav> 
  </v-app>
</template>

<script>
import Snackbar from './components/Snackbar';  
import BreadCrumb from './components/BreadCrumb'; 
export default {
  name: 'App',
  components:{
    Snackbar,
    BreadCrumb
  },
  data: () => ({
  }),
  computed: {
  },
  watch: {
    '$route' (to, from) {
      document.title = to.meta.title || 'Inovenso ERP'
    }
  },
}
</script>